export default async function ( response ) {
	const contentDisposition = response.headers.get( 'Content-Disposition' );
	const filename = contentDisposition.split( '=' )[1];

	const blob = await response.blob();

	if ( window.navigator.msSaveOrOpenBlob ) { // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
		window.navigator.msSaveBlob( blob, `${filename}` );
	}
	else {
		const a = window.document.createElement( 'a' );
		a.href = window.URL.createObjectURL( blob );
		a.download = `${filename}`;
		document.body.appendChild( a );
		a.click(); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
		document.body.removeChild( a );
	}
}
